import { gql } from '@apollo/client';

export const GET_NAVIGATION_CHANNELS = gql`
    query {
        rfqProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        orderProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        orderConfirmationProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        invoiceProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        propertyBillProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        deliveryNoteProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        listOfServicesProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }

        universalProcessingChannels {
            id
            name
            openDocumentsCount
            automationEnabled
        }
    }
`;
